<template>
    <main-block> 
        <main-title class="page__title_between">
            <div class="dashboard-title page__title_mb12"> 
                <p>Dashboard #{{$route.params.id}} </p>
 
                <div v-if="item && showChart && labels" class="dashboard-actions">
                    <router-link 
                        class="main-btn main-btn_ml main-btn_green"
                        :to="{name: `Calendar`, query: { 
                            first_day: item.simulation_from,
                            last_day: item.simulation_to,
                            id: item.id,
                            db_schema: item.db_schema
                        }}"
                    > 
                        Handymen's schedule
                    </router-link> 

                    <router-link class="main-btn main-btn_ml" to='/'>Create another one</router-link>
                </div> 
            </div> 
            <!-- ACTIONS START  -->
            <!-- <main-actions/> -->
            <!-- ACTIONS END  -->
        </main-title> 
 
        <main-breadcrumbs 
            class="breadcrumbs_bb"
            v-if="showBreadcrumbs"
            :links="links"
        />
      
        <div class="result" v-if="item && showChart && labels">
            <div class="result-top">
                <!-- DATA START --> 
                <history-item-body 
                    class="history-item__body_show"
                    :item="item"
                >
                    <main-comments  
                        :comments="comments"
                        :id="$route.params.id"
                    />
                </history-item-body>  
                <!-- DATA END -->  
            </div>
            
            <div class="result-charts">
                <!-- CHART ITEM START  --> 
                <chart
                    :id="'hourly'"
                    :labels="labels.hourly"
                    :width="450"
                    :height="350" 
                    :options="charts.hourly.options"
                />
                <!-- CHART ITEM END  --> 

                <!-- CHART CALENDAR FULL START --> 
                <chart
                    :id="'daily'"
                    :labels="labels.daily"
                    :width="520"
                    :height="352" 
                    :options="charts.daily.options"
                />
                <!-- CHART CALENDAR FULL END -->

                <!-- CALENDAR SECTORS START  --> 
                <chart
                    :id="'sectors'"
                    :labels="charts.sectors.labels"
                    :width="400"
                    :height="343" 
                    :options="charts.sectors.options"
                />
                <!-- CALENDAR SECTORS END  --> 
            </div>
        </div> 
    </main-block> 
</template>

<script>
import {mapActions, mapGetters, mapMutations} from "vuex";
import ChartHelper from '@/helpers/chart/index';

import historyItemBody from '@/components/lists/history/itemBody';
import Chart from '@/components/charts/Chart'; 

export default {
    components: {
        historyItemBody,
        Chart
    }, 
    computed: {
        ...mapGetters({
            item: 'simulation/simulation',
            comments: 'simulation/simulationComments',
            showChart: 'charts/show'
        })
    },
    data() {
        return { 
            showBreadcrumbs: false,
            links: [
                {
                    id: 1,
                    title: 'Main',
                    url: '/'
                },
                {
                    id: 2,
                    title: 'History',
                    url: '/history'
                }
            ],
            labels: {
                daily: null,
                hourly: null
            },
            charts: {
                hourly: {
                    labels: [
                        '08-09',  '09-10', '10-11', '11-12', '12-13',
                        '13-14', '14-15', '15-16', '16-17', '17-18', '18-19'
                    ],
                    options: {
                        scales: {
                            xAxes: [{
                                stacked: true,
                                ticks: {
                                    min: 0,
                                    max: 100
                                }  
                            }],
                            yAxes: [{
                                stacked: true,
                                ticks: {
                                    min: 0,
                                    max: 100
                                }   
                            }, {
                                id: "hour-demand",
                                stacked: false,
                                display: false,
                                ticks: {
                                    beginAtZero: true,
                                    min: 0,
                                    max: 100
                                },
                                type: 'linear'
                            }, {
                                id: "hour-traffic",
                                stacked: false,
                                display: false,
                                ticks: {
                                    beginAtZero: true,
                                    min: 0,
                                    max: 100
                                },
                                type: 'linear'
                            }]
                        }
                    }
                },
                daily: {
                    options: {
                        scales: {
                            xAxes: [{
                                stacked: true
                            },],
                            yAxes: [{
                                stacked: true,
                                ticks: {
                                    min: 0,
                                    max: 100
                                }   
                            }, {
                                id: "day-demand",
                                stacked: false,
                                display: false,
                                ticks: {
                                    beginAtZero: true,
                                    min: 0,
                                    max: 100
                                },
                                type: 'linear'
                            }, {
                                id: "day-traffic",
                                stacked: false,
                                display: false,
                                ticks: {
                                    beginAtZero: true,
                                    min: 0,
                                    max: 100
                                },
                                type: 'linear'
                            }]
                        }
                    }
                },
                sectors: {
                    labels: ['Central', 'East', 'Donaustadt', 'North', 'South'],
                    options: { 
                        scales: {
                            xAxes: [{
                                stacked: true
                            }],
                            yAxes: [{
                                stacked: true,
                                ticks: {
                                    min: 0,
                                    max: 100
                                }   
                            }]
                        }
                    }
                }
            }
        }
    },
    methods: {
        ...mapMutations({
            clear: 'charts/clear'
        }),
         ...mapActions({ 
            getById: 'simulation/getById',
            getComments: 'simulation/getComments',
            getCharts: 'charts/getCharts'
        }),
    },
    async created() { 
        await this.getComments(this.$route.params.id); 
        await this.getById(this.$route.params.id); 
        this.labels.hourly = new ChartHelper.fullChartHours({timeFrom: this.item.schedule_from, timeTo: this.item.schedule_to}).labels;
        this.labels.daily = new ChartHelper.fullChartDates({ dayFrom: this.item.simulation_from, dayTill: this.item.simulation_to}).days;
        await this.getCharts(this.$route.params.id);

        this.links.push({
            id: 3,
            title: this.$route.params.id
        });

        this.showBreadcrumbs = true;
    },
    beforeDestroy() {
        this.clear();
    }
}
</script>

<style lang="scss">
.dashboard {
    &-title {
        width: 100%;
        display: flex;
        align-items: flex-end;
        height: 32px;

        &_between {
            justify-content: space-between;
        }
    } 

    &-actions {
        height:32px; 
        display:flex;
    }
} 
.result {
    &-top {
        display: flex;
        height: 328px;
    }

    &-charts {
        padding: 24px;
        display: flex;
        flex-wrap: wrap; 
        overflow: auto; 
    }
} 

canvas {
    transition: all .2s ease-in;
}
</style>
